import { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import SimplePage from "./pages/SimplePage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">

      <BrowserRouter>

        <ScrollToTop />

        <Header />

        <main className="flex-1">

          <Routes>

            {/* ================= HOME ================= */}
            <Route path="/" element={<Home />} />

            {/* ================= ABOUT ================= */}
            <Route
              path="/about"
              element={
                <SimplePage
                  title="About Us"
                  subtitle="Discover the mission, vision, and values driving the Akwa Ibom State Universal Basic Education Board."
                />
              }
            />

            {/* ================= DEPARTMENTS ================= */}
            <Route
              path="/departments"
              element={
                <SimplePage
                  title="Departments"
                  subtitle="Meet the directorates and units that power AKSUBEB's mandate across Akwa Ibom State."
                />
              }
            />

            {/* ================= PROGRAMS ================= */}
            <Route
              path="/programs"
              element={
                <SimplePage
                  title="Programs"
                  subtitle="From BESDA to STEM training — explore the programs improving basic education in our state."
                />
              }
            />

            {/* ================= RECRUITMENT ================= */}
            <Route
              path="/recruitment"
              element={
                <SimplePage
                  title="Recruitment"
                  subtitle="Recruitment opportunities, application guidelines, employment information, and official AKSUBEB recruitment updates."
                />
              }
            />

            {/* ================= PROJECTS ================= */}
            <Route
              path="/projects"
              element={
                <SimplePage
                  title="Projects"
                  subtitle="Infrastructure development and renovation projects executed by AKSUBEB."
                />
              }
            />

            {/* ================= MEDIA ================= */}
            <Route
              path="/media"
              element={
                <SimplePage
                  title="Media"
                  subtitle="News, press releases, photos, and videos from AKSUBEB."
                />
              }
            />

            {/* ================= CONTACT ================= */}
            <Route
              path="/contact"
              element={
                <SimplePage
                  title="Contact Us"
                  subtitle="Get in touch with the Akwa Ibom State Universal Basic Education Board."
                />
              }
            />

          </Routes>

        </main>

        <Footer />

      </BrowserRouter>
    </div>
  );
}

export default App;